/**
 * Représente un noeud d'un menu contextuel à plusieurs niveaux.
 */
export class MultiLevelContextMenuItem {
    /**
     * Constructeur.
     * @param text : Texte du noeud.
     * @param data : Donnée associée au noeud.
     * @param childrenNodes : Liste des noeuds enfants.
     */
    constructor(
        public text: string,
        public data: string,
        public childrenNodes: MultiLevelContextMenuItem[] = null
    ) {}
}
